import '../styling/calendarToolbar.css'
import { Navigate } from 'react-big-calendar'

const CalendarToolbar = (props) => {

    const goBack = () => {
        props.onNavigate(Navigate.PREVIOUS)
    }

    const goNext = () => {
        props.onNavigate(Navigate.NEXT)
    }

    let today = new Date()
    let currentYear = today.getFullYear().toString()
    let firstDayLabel = props.label.split(" - ")[0].slice(0, -1)
    let firstDate = new Date(Date.parse(firstDayLabel + " " + currentYear))

    let lastDayLabel = props.label.split(" - ")[1].slice(0, -1)
    let lastDate = new Date(Date.parse(lastDayLabel + " " + currentYear))
    let disableGoBack = today >= firstDate && today <= lastDate

    return (
        <div className="toolbar">
            <div className='navigationButtons'>
                <span className='toolbar-go-back' style={{ color: `${disableGoBack ? "lightGray" : "black"}` }} onClick={disableGoBack ? null : goBack}>{"<"}</span>
                <span className='toolbar-label'>{props.label}</span>
                <span className='toolbar-go-next' onClick={goNext}>{">"}</span>
            </div>
        </div>
    )
}

export default CalendarToolbar
